import { FunctionComponent, memo } from 'react';
import {
  EventItemUnavailable,
  HorizontalStoryFeedCardProps,
  HorizontalStoryFeedContentCommon,
  useIsEventUnavailable,
} from '../../../../shared';
import { HorizontalStoryFeedCardWrapper } from '../HorizontalStoryFeedCardWrapper';

export const HorizontalStoryFeedEvent: FunctionComponent<HorizontalStoryFeedCardProps> = memo(
  ({ card }) => {
    const isEventUnavailable = useIsEventUnavailable();

    const { isPinnedToTopOfNewsFeed, isPinnedToTopOfStory, event } = card;

    if (isEventUnavailable(event)) {
      return (
        <HorizontalStoryFeedCardWrapper card={card}>
          <EventItemUnavailable />
        </HorizontalStoryFeedCardWrapper>
      );
    }

    if (!event) {
      return null;
    }

    return (
      <HorizontalStoryFeedCardWrapper card={card}>
        <HorizontalStoryFeedContentCommon
          isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
          isPinnedToTopOfStory={isPinnedToTopOfStory}
          title={event.name}
          htmlText={event.descriptionHTML}
        />
      </HorizontalStoryFeedCardWrapper>
    );
  }
);
